<template>
  <div 
    :class="[
      'layout-fullscreen', 
      {
        'is-loading': loading,
      }  
    ]"
  >
    <div 
      class="layout-fullscreen--header"
      ref="header"
    >
      <div 
        class="layout-fullscreen--logo"
      >
        <img 
          :src="logoUrl"
          ref="logoImg" 
          class="logo"
        />

        <img 
          :src="goutte1Url" 
          ref="goutte1"
          class="goutte1"
        />

        <img 
          :src="goutte2Url"
          ref="goutte2"
          class="goutte2"
        />

        <img 
          :src="goutte3Url"
          ref="goutte3"
          class="goutte3"
        />
      </div>

      <h1 ref="logoTitle" >
        PIKaDICK
      </h1>
    </div>

    <div class="layout-fullscreen--content">
        <router-view ></router-view>
      <!-- <transition name="fade-in" mode="out-in" appear>
      </transition> -->
      <!-- <router-view 
        v-if="!loading"
        v-slot="{ Component }"
      >
        <transition name="fade-in" mode="out-in" appear>
          <component :is="Component" />
        </transition>
      </router-view> -->
    </div>
    
    <div 
      v-if="!loading"
      class="layout-fullscreen--footer"
    >
      <div 
        v-if="!loading"
        class="layout-fullscreen--menu is-grid has-col-5"
      >
        <div 
          class="is-col-1"
        >
          <router-link
            :to="{ name: 'config' }"
          >
            <i class="uil uil-users-alt"></i>

            <p>
              Membres
            </p>
          </router-link> 
        </div>

        <div 
          class="is-col-1 activity"
          @click="caTourne"
        >
          <i class="uil uil-bell"></i>

          <p>
            Activité
          </p>
        </div>

        <div 
          class="is-col-1 messages"
        >
          <router-link
            :to="{ name: 'home' }"
          >
            <i class="uil uil-search"></i>

            <p>
              Messages
            </p>
          </router-link>
        </div>

        <div class="is-col-1">
          <router-link
            :to="{ name: 'search' }"
          >
            <i class="uil uil-search"></i>

            <p>
              Rencontre
            </p>
          </router-link>
        </div>

        <div class="is-col-1">
          <router-link
            :to="{ 
              name: 'profile-dylan',
                params: {
                id: 'dylan',
              }
            }"
          >
            <i class="uil uil-bars"></i>

            <p>
              Profil
            </p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, nextTick } from 'vue'
  import anime from 'animejs'
  import logoUrl from '@assets/images/logo.png'
  import goutte1Url from '@assets/images/goutte1.png'
  import goutte2Url from '@assets/images/goutte2.png'
  import goutte3Url from '@assets/images/goutte3.png'

  export default {
    setup () {
      const header = ref(null)
      const logoImg = ref(null)
      const goutte1 = ref(null)
      const goutte2 = ref(null)
      const goutte3 = ref(null)
      const logoTitle = ref(null)
      const loading = ref(true)

      let timeline = null

      onMounted(() => {
        nextTick(() => {
          timeline = anime.timeline({
            easing: 'easeOutExpo',
            duration: 500,
            complete: () => {
              logoTitle.value.style.opacity = 1
              loading.value = false
            },
          })
          
          timeline.add({
            targets: [
              goutte1.value,
              goutte2.value,
              goutte3.value,
            ],
            opacity: [0, 1],
            translateY: [20, 0],
            translateX: (_, index) => [-5, 0, 5][index],
            duration: 500,
            delay: (_, index) => index * 500,
          })

          timeline.add({
            targets: logoTitle.value,
            opacity: [0, 1],
            translateY: [50, 0],
            duration: 500,
          })

          timeline.add({
            targets: logoImg.value,
            opacity: 0,
            duration: 300,
            delay: 250,
            // delay: duration,
          })

          timeline.add({
            targets: [
              goutte1.value,
              goutte2.value,
              goutte3.value,
            ],
            opacity: 0,
            // translateY: -100,
          }, '-=350')

          timeline.add({
            targets: logoTitle.value,
            opacity: [1, 0],
            // translateY: [50, 0],

          }, '-=500')

          timeline.add({
            targets: header.value,
            maxHeight: 100,
            // opacity: [0, 1],
            top: ['50vh', 0],
            height: ['100%', 100],
            translateY: ['-50%', 0],
            // duration: 250,
            duration: 1,
            // delay: 
          }) //, '-=150')
          
          timeline.add({
            targets: logoImg.value.parentNode,
            duration: 1,
            maxHeight: [300, 0],
          }, '-=250')

          // timeline.add({
          //   targets: header.value,
          //   duration: 50,
          // })
        })
      })

      function caTourne () {
        window.location = window.location.origin
      }

      return { 
        header,
        logoImg,
        goutte1,
        goutte2,
        goutte3,
        logoTitle,
        loading,
        caTourne,
        logoUrl,
        goutte1Url,
        goutte2Url,
        goutte3Url,
      }
    }
  }
</script>

<style lang="scss">
  .layout-fullscreen {
    position: fixed;
    top: 0px;
    left: 0px;
    min-width: 100vw;
    min-height: 100vh;
    overflow: hidden;

    &:before {
      content: "";
      position: fixed;
      top: 0px;
      left: 0px;
      height: 100vh;
      width: 100vw;
      z-index: 2;   
      background: white;
      opacity: 0;
      transform: translate3d(0, -100vh, 0);
      transition: opacity 0.3s $magic-animation 0s, transform 0.1s linear 0.4s;
    }

    &.is-loading {
      &:before {
        z-index: 1;   
        transform: translate3d(0, 0, 0);
        transition: opacity 0s $magic-animation, transform 0s linear 0s;
        opacity: 1;
      }

      .layout-fullscreen--header,
      .layout-fullscreen--footer {
        border-bottom-color: transparent;
        border-top-color: transparent;
      }

      .layout-fullscreen--header,
      .layout-fullscreen--logo {
        max-height: 100vh; 
      }

      h1 {
        color: $black-400;
        // opacity: 0, 
      }
    }

    &--header {
      position: relative;
      max-height: 100px; 
      top: 50vh;
      height: 100px;
      border-bottom: 1px solid;
      border-bottom-color: var(--color);
      // margin-bottom: 1rem;
      transition: border-color 0.3s $magic-animation;
      z-index: 2;

      h1 {
        font-size: 1.7rem;
        margin-top: 2rem;
        margin-bottom: 1rem;
        text-align: center;
        color: var(--color);
        transition: color 0.3s $magic-animation;
        opacity: 1;
      }
    }

    &--footer {
      position: relative;
      height: 100px;
      max-height: 100px;
      border-top: 1px solid;
      border-top-color: var(--color);
      transition: border-color 0.3s $magic-animation;
    }

    &--logo {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      
      .logo {
        max-width: 70%;
        background: var(--color);
        border-radius: 25%;
      }

      .goutte1, .goutte2, .goutte3 {
        position: absolute;
      }

      .goutte1 {
        left: calc(50% - 45px);
        height: 50px;
        top: 30px;
      }

      .goutte2 {
        left: calc(50% - 5px);
        height: 30px;
        top: 20px;
      }

      .goutte3 {
        left: calc(50% + 5px);
        height: 50px;
        top: 40px;
      }
    }

    &--content {
      position: relative;
      max-height: calc(100vh - 200px); 
      height: 100vh;
      padding: 1rem 0;
      // overflow: auto;
    }

    &--menu {
      max-width: 90%;
      margin: 0 auto;
      margin-top: 1rem;
      margin-bottom: 2rem;
      text-align: center;

      p {
        font-size: 12px;
      }

      i {
        font-size: 24px;
      }
    }

    .messages,
    .activity {
      position: relative;

      &:before {
        content: "21";
        position: absolute;
        top: 0px; 
        right: 0px;
        transform: translate3d(25%, -50%, 0);
        padding: 0.1rem 0.5rem;
        border-radius: 5px;
        background: red;
        color: white;
        font-size: 12px;
      }
    }

    .messages {
      &:before {
        content: "3";
      }
    }

    .sperm {
      position: relative;

      &:before {
        content: "💦";
        position: absolute;
        top: 0px; 
        left: 50%;
        transform: translate3d(-50%, calc(-50% - 2px), 0) rotate(225deg);
        font-size: 12px;
      }
    }

    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .fade-in-enter-active {
      transition: all 3s ease-out;
    }

    .fade-in-leave-active {
      transition: all 8s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .fade-in-enter-from {
      opacity: 1;
    }

    .fade-in-leave-to {
      // transform: translateX(20px);
      opacity: 0;
    }
  }

</style>